import store from '../store/store'

export default function () {
  const app = store.getters.currentApp
  const currentBackend = (() => {
    if (app === 'carnot')
      return 'https://api.carnot.hublot.io/'
    else
      return 'https://api.hublot.io/'
  })()

  const proxyBackend = (() => {
    if (app === 'carnot')
      return 'https://database-proxy-carnot.hublot.io/'
    else
      return 'https://database-proxy.hublot.io/'
  })()

  const sharedMailSenderBackend = 'https://api.hublot.io/mail-sender/'


  return {
    backend : currentBackend,
    notionBackend :  currentBackend + 'notion/',
    databaseBackend :  currentBackend + 'database/',
    imageApi : currentBackend + 'image',
    chatImageApi : currentBackend + 'chat/v2/image/',
    shopbackend : currentBackend + 'client/',
    enrollBackend : currentBackend + 'client/enroll',
    discoverBackend :  currentBackend + 'client/enroll/discover',
    heatmapApi: currentBackend + 'statistiques',
    imageBackend : currentBackend+  'image/',
    infoBackend: currentBackend+ 'info/',
    integrationBackend: currentBackend + 'integration/',
    integrationParseBackend: currentBackend + 'integration/parse/',
    integrationEnrollBackend : currentBackend + 'integration/enroll/',
    parserBackend: currentBackend + 'parser',
    sqlbackend: currentBackend+ 'sqlupdate/',
    queryBackend: proxyBackend + 'database-proxy/',
    fishBackend: currentBackend+ 'fish',
    parserResultsV2Backend: currentBackend + 'parser-v2-results',
    parserExcelV2Backend: currentBackend + 'parser-v2-excel',
    parserV2Backend: currentBackend + 'parser-v2',
    externalConnectionBackend: currentBackend + 'integration-management/',
    erpUploadBackend: currentBackend + 'erp-import-upload/',
    vusionBackend: currentBackend + 'vusion/',
    meteoBackend: currentBackend + 'erp-insert-meteo/',
    apiDocsBackend: currentBackend + 'api-docs/',
    CallsBackend: currentBackend + '3cx/',
    favQueryBackend: currentBackend + 'favquery',
    pennylaneBackend: currentBackend + 'pennylane',
    stockBackend: 'https://api.hublot.io/inventory',  // URL fixe — indépendante du contexte app
    chronopostBackend: 'https://api.hublot.io/chronopost',  // URL fixe — indépendante du contexte app
    shipmentsBackend: 'https://api.hublot.io/shipments/',  // URL fixe — indépendante du contexte app
    knoxBackend: 'https://api.hublot.io/knox/',  // URL fixe — Knox regroupe poissonnerie + boucherie
    strappBackend: 'https://api.hublot.io/strapp/',  // URL fixe — indépendante du contexte app
    renewalBackend: currentBackend + 'client/device-renewal',
    keycloakAuthBackend: currentBackend + 'keycloak-auth/',
    mailSenderBackend: sharedMailSenderBackend,
    formationBackend: currentBackend + 'formation',
    pluBackend: currentBackend + 'plu/',
  }
}